export enum LocalStorageKey {
  NEWSLETTER_POPUP_DATE = 'newletterPopupDate',
  USER_HAS_JOINED_NEWSLETTER = 'isUserJoinedNewsLetter',
  HAS_DISPLAYED_QUOTATION_POP_UP = 'hasDisplayedQuotationPopup',
  PRODUCT_POPUP_DATE = 'productPopupDate'
}
